// extracted by mini-css-extract-plugin
export default {"container":"src-feature-customer-__customer-map_container","map":"src-feature-customer-__customer-map_map"};